/** Shared width for host offer view, wallet/instance detail, and My Passes. */
export const PASS_DETAIL_MAX_WIDTH = 960;
export const PASS_BOARDING_STUB_WIDTH = 260;

export const passDetailPageSx = {
  py: { xs: 2, sm: 4 },
  px: { xs: 1, sm: 2 },
  pb: { xs: 8, sm: 10 },
  maxWidth: PASS_DETAIL_MAX_WIDTH,
  width: '100%',
  mx: 'auto',
} as const;

/** Shared geometry for type + status chips sitting together on pass surfaces. */
export const passMetaChipSx = {
  width: 'fit-content',
  maxWidth: '100%',
  flexShrink: 0,
  height: 22,
  fontWeight: 500,
  '& .MuiChip-label': { px: 0.75, fontSize: '0.75rem', lineHeight: 1.2 },
  '& .MuiChip-icon': {
    fontSize: 14,
    marginLeft: '6px !important',
    marginRight: '-2px !important',
  },
} as const;

/** Tutors, buyers, and room thumbs in pass identity rows. */
export const PASS_IDENTITY_AVATAR_SIZE = 24;
